// Style
import "./OffersList.scss";

// Components
import Accordion from "../accordion/Accordion";
import Offer from "../offer/Offer";

// External Type
import {
	OfferAdditionalInfo,
	RecapPageOfferAdditionalDetail,
	RecapPageOfferSection
} from "@sky/quotations-typescript-angular-sdk";
import { RecapPageOfferCostsSection } from "@sky/quotations-typescript-angular-sdk/model/recapPageOfferCostsSection";

// Element
export const OffersList = (offers: RecapPageOfferSection): JSX.Element => {
	const { name: packageName } = offers;

	return (
		<section className="offers-list__wrp">
			<p className="medium sky-body offers-list__title">{packageName}</p>

			{offers.costs?.map((costs: RecapPageOfferCostsSection, idx: number) => (
				<Offer key={"offer_component_" + idx} {...costs} />
			))}

			{offers?.offerAdditionalInfo?.map((item: OfferAdditionalInfo) => (
				<p className="offers-list__additional-info">{item.text}</p>
			))}

			{offers?.additionalDetails?.map(
				(row: RecapPageOfferAdditionalDetail, index: number) => {
					return (
						<Accordion
							isOffersAccordion={true}
							key={index + 10}
							index={index + 10}
							title={row.additionalDetailsHeading}
							contentDetailOffer={
								row.additionalDetailsItems
									? row.additionalDetailsItems
									: /* istanbul ignore next: this is a fallback always true */ []
							}
						/>
					);
				}
			)}
		</section>
	);
};

export default OffersList;
